<mat-sidenav-container>
  <mat-sidenav
    #sidenav
    mode='side'
    opened='true'
    id='sidebar'
  >
    <div class='navbar-brand icon' id='zappLogo'>
      <img src='assets/portal-logo.svg' alt=''>
    </div>

    <lib-sidemenu></lib-sidemenu>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar id='toolbar'>
      <button mat-icon-button (click)='sidenav.toggle()'>
        <mat-icon>menu</mat-icon>
      </button>
      <div class='spacer'></div>
    </mat-toolbar>
    <div id='routerOutletContent'>
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
